import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';

import PropTypes from 'prop-types';
import './mainStyle.scss';

import { authService } from './../../Auth.service';
import ModelView from '../ModelView';
import ModelLanding from '../ModelLanding';
import AdminLayout from '../ModelLanding/Admin';
import AnalyticsView from '../ModelLanding/Analytics/AnalyticsView';
import * as R from 'ramda';

const safeJsonParse = R.tryCatch(JSON.parse, R.always(null));

class ModelLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.authService = new authService();
        this.subscription = this.authService.getLoginStatus().subscribe((status) => {
            if (!status) {
                this.props.history.push('/login');
            }
        });
    }

    render() {
        return (
            <div>
                <div className="row view-container">
                    <div className="w-100 scroll-box">
                        <Switch>
                            <Route exact path={this.props.match.path} component={ModelView} />
                            <Route path={`${this.props.match.path}/list`} component={ModelLanding} />
                            <Route
                                path={`${this.props.match.path}/analytics/report/:reportKey`}
                                component={AnalyticsView}
                            />
                            <Route path={`${this.props.match.path}/admin`} component={AdminLayout} />
                            <Route
                                path={`${this.props.match.path}/view/:modelId/:versionId/:customerId`}
                                component={ModelView}
                            />
                            <Route path={`${this.props.match.path}/create/:customerId`} component={ModelView} />
                        </Switch>
                    </div>
                </div>
            </div>
        );
    }

    componentWillUnmount() {
        if (this.subscription) this.subscription.unsubscribe();
    }

    componentDidMount() {
        let fomUser = localStorage.getItem('FOM_user');
        const session = safeJsonParse(fomUser);
        console.log(' before walkme...! ');
        if (session) {
            console.log(' inside walkme...! ');
            const { userName, fullName } = session.userdata.details;
            window.walkme = {
                userId: userName,
                email: userName,
                fullName: fullName,
            };
        }
        console.log(' after walkme...! ', window.walkme);
    }
}

ModelLayout.propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};

export default withRouter(ModelLayout);
